import React, { useState, useEffect, useRef } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import PolicyInformation from "../../../components/customer/underwriting/PolicyInformation";
import PreloadedClauses from "../../../components/customer/underwriting/PreloadedClauses";
import PageTitle from "../../../components/partials/PageTitle";
import {
  getUnderwritingData,
  resetUnderwriting,
} from "../../../redux/slice/underwriting/underwritingSlice";
import { useDispatch, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";

const UnderwritePolicy = () => {
  const { underwritingData, clauses } = useSelector(
    (state) => state.underwriting
  );
  const { customer_policy_details, single_policy_cover } = useSelector(
    (state) => state.policy
  );
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const [tab, setTab] = useState("policy info");
  const [underWritten, setUnderWritten] = useState(null);
  const [isNext, setIsNext] = useState(false);

  const preloadedClauseRef = useRef();
  const policyInfoRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const breadcrumb = {
    from: {
      title: "customer policy view",
      link: "/admin/customer-policy-view",
    },
    current: {
      title: "underwrite policy",
      link: null,
    },
  };

  useEffect(() => {
    dispatch(resetUnderwriting());
    dispatch(
      getUnderwritingData({
        customer_id: customer_policy_details?.policy_app_details?.customerId,
        policy_application_number:
          customer_policy_details?.policy_app_details?.policyAppNumber,
      })
    );
  }, []);

  useEffect(() => {
    if (
      !user_permissions?.some((permission) => permission.name === "underwrite")
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  if (!underwritingData || !customer_policy_details) {
    return (
      <BeatLoader
        height='80'
        width='80'
        radius='9'
        color='#2e3192'
        ariaLabel='three-dots-loading'
        wrapperStyle={{}}
        wrapperClassName=''
        visible={true}
        className='mt-3'
      />
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Underwriting' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='card'>
        <div className='card-body'>
          <div className='d-flex justify-content-end mb-2'>
            <button
              className='btn btn-sm btn-primary d-flex align-items-center'
              onClick={() => navigate(-1)}
            >
              <BiArrowBack />
              <span>Back</span>
            </button>
          </div>
          <div className='border border-1 rounded-1 p-2'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-4'>
                    <h5>Customer Name</h5>
                    <p className='text-capitalize'>
                      {underwritingData?.policy_app_details?.customerFirstName +
                        " " +
                        underwritingData?.policy_app_details?.customerLastName}
                    </p>
                  </div>
                  <div className='col-md-4'>
                    <h5>Customer Id</h5>
                    <p>{underwritingData?.policy_app_details?.customerId}</p>
                  </div>
                  <div className='col-md-4'>
                    <h5>Office</h5>
                    <p className='text-capitalize'>
                      {underwritingData?.policy_app_details?.office_name}
                    </p>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-4'>
                    <h5>Policy Name</h5>
                    <p className='text-capitalize'>
                      {underwritingData?.policy_app_details?.policyName}
                    </p>
                  </div>
                  <div className='col-md-4'>
                    <h5>Policy Number</h5>
                    <p>
                      {underwritingData?.policy_app_details?.policyAppNumber}
                    </p>
                  </div>
                  <div className='col-md-4'>
                    <h5>Marketer</h5>
                    <p>
                      {underwritingData?.policy_app_details?.agentFirstName +
                        " " +
                        underwritingData?.policy_app_details?.agentLastName}
                    </p>
                  </div>
                </div>
              </div>
              <div className='row my-3'>
                <div>
                  <ul className='nav nav-pills bg-nav-pills nav-justified mb-3'>
                    <li className='nav-item'>
                      <a
                        href='#policy_info'
                        data-bs-toggle='tab'
                        aria-expanded='false'
                        className='nav-link active rounded-0'
                        ref={policyInfoRef}
                      >
                        <i className='mdi mdi-home-variant d-md-none d-block'></i>
                        <span className='d-none d-md-block'>
                          Policy Information
                        </span>
                      </a>
                    </li>
                    <li className='nav-item'>
                      <a
                        href='#profile1'
                        data-bs-toggle='tab'
                        aria-expanded='false'
                        className='nav-link rounded-0'
                        ref={preloadedClauseRef}
                        onClick={() => setIsNext(true)}
                      >
                        <i className='mdi mdi-home-variant d-md-none d-block'></i>
                        <span className='d-none d-md-block'>
                          Preloaded Clauses
                        </span>
                      </a>
                    </li>
                  </ul>
                  <div className='tab-content'>
                    <div className='tab-pane show active' id='policy_info'>
                      <PolicyInformation
                        policyDetails={underwritingData?.policy_app_details}
                        covers={underwritingData?.policy_app_rsk}
                        setUnderWritten={setUnderWritten}
                        ref={preloadedClauseRef}
                        setIsNext={setIsNext}
                        isNext={isNext}
                      />
                    </div>
                    <div className='tab-pane' id='profile1'>
                      <div className='active' id='preloaded'>
                        <PreloadedClauses
                          setUnderWritten={setUnderWritten}
                          underWritten={underWritten}
                          ref={policyInfoRef}
                          clauses={clauses}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnderwritePolicy;
